import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useDeleteBulkImport = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	return useMutation(
		async (importId) => {
			const instance = await InitApi({ accessToken });
			const response = await instance.delete(
				`/publisher/bulk-book-imports/${importId}`
			);
			return response.data;
		},
		{
			onSuccess: (_data, importId) => {
				queryClient.invalidateQueries(["bulkBookImport", importId]);
				queryClient.removeQueries(["bulkBookImport", importId]);
				queryClient.invalidateQueries("bulkBookImports");
				toast.success("Import deleted");
			},
			onError: (error) => {
				toast.error(
					<ServerErrors
						errorMessage={error?.response?.data?.message}
						errors={error?.response?.data?.data}
					/>
				);
			},
		}
	);
};

export default useDeleteBulkImport;
